// Video extensions list
export const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'arf', 'mts', 'm4v', 'wmv', 'ts', 'flv', '3gp'];

// Font-size options list
export const fontSizeOptions = [
  { value: 'fnt-main-10', label: '10 px' },
  { value: 'fnt-main-12', label: '12 px' },
  { value: 'fnt-main-14', label: '14 px' },
  { value: 'fnt-main-24', label: '24 px' },
  { value: 'fnt-main-30', label: '30 px' },
];

// Rewind push time options list
export const rewindPushTimeOptions = [
  { value: '1', label: '1 Sec' },
  { value: '5', label: '5 Sec' },
  { value: '10', label: '10 Sec' },
  { value: '20', label: '20 Sec' },
];

export const MyFilesStatusOptions = [
  { value: 'rework', label: 'Rework' },
  { value: 'proofreading', label: 'Proofreading' },
  { value: 'submitted', label: 'Completed' },
];

export const CGAFileStatusOptions = [
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Done', label: 'Done' },
  { value: 'Failed', label: 'Failed' },
  { value: 'Submitted', label: 'Submitted' },
];